import { Component, ElementRef, HostListener, input, Input, output, ViewChild, } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Statement } from 'src/app/ballot/backend-types';
import { MatDialog } from '@angular/material/dialog';
import { WriteInDialogComponent } from '../write-in-dialog/write-in-dialog.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-unranked-choice',
    imports: [MatButtonModule, MatIconModule, MatTooltipModule],
    templateUrl: './unranked-choice.component.html',
    styleUrl: './unranked-choice.component.scss'
})
export class UnrankedChoiceComponent {
  isMobileScreen = this.breakpointObserver.isMatched('(max-width:1000px)');
  unranked = input.required<Statement>()
  rank = output<Statement>();
  @Input() index: number = 0;
  tooltipText = $localize`Click for additional information`;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private readonly dialog: MatDialog
  ) { }
  
  ngOnInit() {
    this.isMobileScreen = this.breakpointObserver.isMatched('(max-width:1000px)');
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileScreen = this.breakpointObserver.isMatched('(max-width:1000px)');
  }
  
  onRank() {
    if (this.unranked().isWriteIn) {
      this.openWriteInDialog()
    } else {
      this.rank.emit(this.unranked());
    }
  }

  getFocus() {
    const button = document.querySelector(`#rankButton${this.index}`) as HTMLButtonElement;
    if (button) {
      button.focus();
    }
  }

  disableRankButton() {
    const button = document.querySelector(`#rankButton${this.index}`) as HTMLButtonElement;
    if (button) {
      button.disabled = true; 
    }
  }
  

  enableRankButton() {
    const button = document.querySelector(`#rankButton${this.index}`) as HTMLButtonElement;
    if (button) {
      button.disabled = false; 
    }
  }
  

  
    openWriteInDialog() {
      const dialogRef = this.dialog.open(WriteInDialogComponent, {
        width: '350px',
      });
    
      dialogRef.afterClosed().subscribe(result => {
        if (result?.error) {
          console.error("Error from dialog:", result.error); 
        } 
        else if (result?.result) {
          if (this.unranked) {
            this.unranked().description = result.result;
            this.rank.emit(this.unranked());
          }
        } 
      });
    }
    
    isStringEmpty(value: string | null | undefined): boolean {
      return (value == null || (typeof value === "string" && value.trim().length === 0));
    }
  
    isImage(url?: string): boolean {
      const imageEndings = ['png', 'svg', 'jpg', 'jpeg']
      if (url) {
        const ending = url.split('.').pop()
        return (ending) ? imageEndings.includes(ending) : false
      } else {
        return false
      }
    }

}
